// removed by extract-text-webpack-plugin
module.exports = {"radio":"Radio__radio___1Nj2y","bordered":"Radio__bordered___1E-Wg","noMargin":"Radio__noMargin___UfIPf","text":"Radio__text___34w7V","marginLeft":"Radio__marginLeft___3j4Z1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/radio/Radio.scss
// module id = 1634
// module chunks = 0